import {has, pluck, uniq} from 'ramda';
import {isPlainObj} from 'ramda-adjunct';

import {ApiError, isFetchBaseQueryError} from 'shared/web';

import i18n from '../i18n/i18n';
import {ApiException} from '../types/ApiException';

export function isApiException(errorData: unknown): errorData is ApiException {
  return !!(isPlainObj(errorData) && has('errors', errorData));
}

const NO_CODE = '???';

/**
 * @about Parses catched error from RTK Query
 */
export function getApiErrorMessages(error: ApiError, defaultErrorMessage?: string) {
  const defaultMessage = defaultErrorMessage ?? i18n.t('general.labels.error');
  if (!isFetchBaseQueryError(error) || !isApiException(error?.data)) {
    return defaultMessage;
  }

  /**
   * Filter out messages without proper code
   * TODO: Translate messages by code
   */
  const errors = error?.data?.errors.filter(
    (error) => error?.message && error?.code && error?.code !== NO_CODE
  );

  /**
   * Get unique error messsages
   */
  const messages = uniq(pluck('message', errors));

  return !!messages.length ? messages : defaultMessage;
}
